export interface OfferCodeGroupType {
  GroupId: string;
  Expiry: string;
  PromoCodeId: string;
  ProductId: string;
  PriceTemplateId: string;
  OfferCodes: FormDataEntryValue | null;
}

export const offerCodeGroupInitialState: OfferCodeGroupType = {
  GroupId: '',
  Expiry: '',
  PromoCodeId: '',
  ProductId: '',
  PriceTemplateId: '',
  OfferCodes: null,
};
